import Form from './TestimonialsForm'
import isEmpty from './TestimonialsIsEmpty'
import Section from './TestimonialsSection'
import Thumbnail from './TestimonialsThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
